module.exports = __webpack_public_path__ + "img/MES2Area_selection.0c649322.png";